/**
 * ViewModeButton - Reusable View Mode Toggle Button Component
 * 
 * SOLID Principle: Single Responsibility Principle (SRP)
 * Purpose: Renders a button for switching between different view modes
 * (graph vs table view).
 * 
 * Responsibilities:
 * - Render button with appropriate styling based on active state
 * - Handle click events for view mode switching
 * - Provide accessible button interface
 */

import React from 'react';
import styles from '../SensorDashboard.module.css';

export const ViewModeButton = React.memo(({ mode, isActive, onClick, children }) => (
  <button
    onClick={onClick}
    className={`${styles.btn} ${isActive ? styles.btnActive : ''}`}
  >
    {children}
  </button>
));

ViewModeButton.displayName = 'ViewModeButton';

export default ViewModeButton;